import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EServicePriceType } from '@irembo-andela/irembogov3-common';

interface IPricingTypesOption {
  label: string;
  value: EServicePriceType;
}

@Component({
  selector: 'irembogov-toggle-button-1',
  templateUrl: './toggle-button.component.html',
})
export class ToggleButtonComponent {
  @Input() selectedOption?: string;
  @Input() options: IPricingTypesOption[] = [];
  @Output() selectOption = new EventEmitter<EServicePriceType>();

  onSelectOption(value: EServicePriceType) {
    this.selectOption.emit(value);
  }
}
